"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = triggerDOMEvent;

var _triggeronedomevent = _interopRequireDefault(require("./_triggeronedomevent"));

var _defs = _interopRequireDefault(require("../_core/defs"));

var _foreach = _interopRequireDefault(require("../_helpers/foreach"));

// triggers DOM event on bound nodes
function triggerDOMEvent(object, key, eventName, selector, triggerArgs) {
  var def = _defs["default"].get(object);

  if (!def) {
    return;
  }

  var props = def.props;
  var propDef = props[key];

  if (!propDef) {
    return;
  }

  var bindings = propDef.bindings;

  if (!bindings) {
    return;
  }

  (0, _foreach["default"])(bindings, function (_ref) {
    var node = _ref.node;

    if (selector) {
      // if selector is given trigger an event on all node descendants
      var descendants = node.querySelectorAll(selector);
      (0, _foreach["default"])(descendants, function (descendant) {
        (0, _triggeronedomevent["default"])({
          node: descendant,
          eventName: eventName,
          triggerArgs: triggerArgs
        });
      });
    } else {
      // trigger an event for single node
      (0, _triggeronedomevent["default"])({
        node: node,
        eventName: eventName,
        triggerArgs: triggerArgs
      });
    }
  });
}
//# sourceMappingURL=_triggerdomevent.js.map